document.addEventListener("DOMContentLoaded", function () {
  function playVisibleVideo() {
    document.querySelectorAll('.product__media-wrapper video').forEach((video) => {
      const rect = video.getBoundingClientRect();
      const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (inView) {
        video.muted = true;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }

  // Run once
  playVisibleVideo();

  // Run on scroll/change
  document.addEventListener('scroll', playVisibleVideo);
});
